module.exports = __webpack_public_path__ + "static/img/loading-3-fr.07cc432.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/load/img/loading-3-fr.png
// module id = 2n+D
// module chunks = 1